import { root, id } from './content-destinations';
import * as idEndpoints from './id';

export const contentDestinations = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
};
